export default __webpack_public_path__ + "static/media/photo_carole_pied.8e8576f0.JPG";